<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li><a href="#"> <i class="uil-home-alt"></i> </a></li>
          <li>{{ this.$t('general.settings') }}</li>
        </ul>
      </nav>
    </div>
    <div uk-grid>

      <div class="uk-width-1-3@m uk-flex-last@m">
        <nav class="responsive-tab style-3 setting-menu card"
          uk-sticky="top:30 ; offset:100; media:@m ;bottom:true; animation: uk-animation-slide-top">
          <ul>
            <li :class="isActiveAccount ? 'uk-active' : ''"><a href="#" @click.prevent="changeIsActive(1)"><i
                  class="uil-hdd"></i> {{ $t('general.account_settings') }}</a></li>
            <li :class="isActiveUser ? 'uk-active' : ''"><a href="#" @click.prevent="changeIsActive(2)"><i
                  class="uil-user"></i> {{ $t('general.user_settings') }}</a></li>
            <li :class="isActiveAppearance ? 'uk-active' : ''"><a href="#" @click.prevent="changeIsActive(3)"><i
                  class="uil-paint-tool"></i>{{ $t('general.view_settings') }}</a></li>
            <li :class="isActiveLegalTexts ? 'uk-active' : ''"><a href="#" @click.prevent="changeIsActive(4)"><i
                  class="uil-info-circle"></i>{{ $t('general.illumination_text') }}</a></li>
          </ul>
        </nav>
      </div>

      <div class="uk-width-expand">

        <div v-if="errorMessages" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color:red;">
            <i class="uil-exclamation-triangle"></i> {{ errorMessages }}
          </p>
        </div>
        <div v-if="successMessage" class="uk-alert-success" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color:green;">
            <i class="uil-exclamation-triangle"></i> {{ $t('general.update_success') }}
          </p>
        </div>
        <div class="card rounded" v-if="isActiveAccount">
          <div class="p-3 d-flex justify-content-between">
            <h4 class="mb-0"><i class="uil-hdd"></i> {{ $t('general.account_settings') }} </h4>
          </div>
          <hr class="m-0">
          <default-loading v-if="form_loading"></default-loading>
          <form v-else class="uk-child-width-2-2@s uk-grid-small p-4" uk-grid>
            <div class="form-group row domain">
              <div class="col-md-12">
                <label class="col-form-label">{{ this.$t('institution.domain_name') }}<span
                    class="required">*</span></label>
                <div class="d-flex">
                  <input type="text" class="form-control" id="domain" name="name" disabled placeholder=""
                    :value="item.alias"><span>.softinya.com</span>
                </div>
                <p class="note"><i class="uil-exclamation-octagon"></i> {{ $t('general.only_superadmin_can_edit') }} </p>
              </div>
            </div>

            <div class="form-group row domain">
              <div class="col-md-12">
                <label class="col-form-label"> {{ $t('general.point_coin_rate') }} <span class="required">*</span></label>
                <div class="d-flex ">
                  <input type="text" class="form-control" id="point_coin_rate" name="point_coin_rate" placeholder=""
                    v-model="item.point_coin_rate"><span>{{ $t('general.point') }} = 1 coin</span>
                </div>
                <div class="uk-flex uk-flex-left" style="gap: 10px;">
                  <button class="btn btn-warning" type="button" @click="onClickResetPoints">{{ $t('general.reset_points')
                  }}</button>
                  <button class="btn btn-warning-light" type="button" @click="onClickResetCoins">
                    {{ $t('general.reset_coins') }}</button>
                </div>
              </div>
            </div>

            <div class="form-group row domain">
              <div class="col-md-12">
                <label class="col-form-label"> {{ $t('general.liked_trainings_listing_score') }} <span
                    class="required"></span></label>
                <select class="form-control" v-model="item.most_popular_education_rate"
                  name="most_popular_education_rate">
                  <option value="0">{{ $t('general.over_0_points') }}</option>
                  <option value="1">{{ $t('general.over_1_points') }}</option>
                  <option value="2">{{ $t('general.over_2_points') }}</option>
                  <option value="3">{{ $t('general.over_3_points') }}</option>
                  <option value="4">{{ $t('general.over_4_points') }}</option>
                  <option value="5">{{ $t('general.5_points') }} </option>
                </select>
              </div>
            </div>

            <!-- Kullanıcı Kayıt Ayarları -->
            <div class="form-group row domain mb-0">
              <div class="col-md-12">
                <div class="form-group list row mb-2 align-items-center">
                  <div class="col-auto pr-2">
                    <input type="checkbox" v-model="item.is_allowed_register_user" name="">
                  </div>
                  <label class="col col-form-label mb-0 pl-0">{{ $t('general.users_become-members_themselves') }}</label>
                </div>

                <div class="form-group row mt-0 pt-0"
                  style="border-left: 3px solid #e4e6ef; margin-left: 15px; padding-left: 25px; background-color: #f8f9fa; padding-top: 15px; padding-bottom: 15px; border-radius: 4px;">
                  <div class="col-md-12">
                    <label class="col-form-label font-weight-bold mb-2" style="font-size: 0.95rem;">{{ $t('general.allowed_domains') }}</label>
                    <multiselect :disabled="!item.is_allowed_register_user" v-model="domains_allowed_to_register"
                      :options="defaultDomains" :multiple="true" :taggable="true" :searchable="true"
                      :internal-search="true" :close-on-select="false" :allow-empty="true" :open-direction="'bottom'"
                      :placeholder="$t('general.select_or_add_domain')" :tag-placeholder="$t('general.add_domain')"
                      :select-label="$t('general.press_enter_to_select')" :selected-label="$t('general.selected')"
                      :deselect-label="$t('general.press_enter_to_remove')" @tag="addDomain">
                      <template slot="noOptions">
                        <span>{{ $t('general.add_new_domain') }}</span>
                      </template>
                    </multiselect>
                    <p class="mt-2 mb-0" style="font-size: 0.85rem; color: #6c757d;">
                      <i class="icon-feather-info" style="font-size: 14px;"></i>
                      {{ $t('general.recommended_domains_hint') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row mb-3">
              <div class="col-md-12">
                <label class="col-form-label" for="logo">{{ $t('company.dashboard_bg_image') }}</label>

                <div class="position-relative d-flex justify-center justify-content-center">
                  <img v-if="item.search_bg_image && item.search_bg_image_link" style="height: 190px"
                    class="rounded img-fluid logoarea" :src="item.search_bg_image_link" alt="">
                  <img v-else style="height: 190px" class="rounded img-fluid logoarea"
                    src="@/assets/images/shutterstock_130027559.jpg" alt="">
                  <input type="file" class="d-none" id="avatar" @change="processFile($event)">
                  <button @click="inputClick()" type="button" class="btn btn-default btn-icon-label"
                    style="top: 50%;position: absolute;">
                    <span class="btn-inner--icon">
                      <i class="uil-image"></i>
                    </span>
                    <span class="btn-inner--text">{{ $t('general.image_change') }}</span>
                  </button>
                </div>
              </div>
            </div>

          </form>
          <div class="uk-flex uk-flex-right p-4">
            <button class="btn btn-default" @click="onSubmitSelf"> {{ $t("general.save") }} </button>
          </div>
        </div>

        <div class="card rounded" v-if="isActiveUser">
          <div class="p-3 d-flex justify-content-between">
            <h4 class="mb-0"><i class="uil-user"></i> {{ $t('general.user_settings') }}</h4>
          </div>
          <hr class="m-0">
          <default-loading v-if="form_loading"></default-loading>
          <form v-else class="uk-child-width-2-2@s uk-grid-small p-4" uk-grid>



            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label"> {{ $t('general.user_login_method') }} <span
                    class="required"></span></label>
                <select name="login_type" v-model="item.login_type_id">
                  <option v-for="(item, index) in login_types" :value="item.id" :key="index">{{ item.name }}</option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label"> {{ $t('general.user_authentication_method') }} <span
                    class="required"></span></label>
                <select name="authentication_type" v-model="item.authentication_type_id">
                  <option v-for="item in authentication_types" :value="item.id" :key="item.id">{{ item.name }}</option>
                </select>
              </div>
            </div>

            <div class="form-group list row">
              <div class="col-md-1 col-form-label">
                <input type="checkbox" v-model="item.password_change_required" name="" id="opt1">
              </div>
              <label class="col-md-9 col-form-label" for="opt1"> {{ $t('general.create_password_when_first_login') }}
              </label>
            </div>



            <div class="form-group list row">
              <div class="col-md-1 col-form-label">
                <input type="checkbox" v-model="item.R" name="" id="opt3">
              </div>
              <label class="col-md-9 col-form-label" for="opt3"> {{ $t('general.user_change_login_method') }} </label>
            </div>

            <div class="form-group list row">
              <div class="col-md-1 col-form-label">
                <input type="checkbox" v-model="item.is_allowed_authentication_type" name="" id="opt4">
              </div>
              <label class="col-md-9 col-form-label" for="opt4"> {{ $t('general.user_change_authentication_method') }}
              </label>
            </div>
            <div class="form-group list row">
              <div class="col-md-1 col-form-label">
                <input type="checkbox" v-model="item.auto_training_assignment" name="" id="opt5">
              </div>
              <label class="col-md-9 col-form-label" for="opt5">
                {{ $t('general.assign_catalog_trainings_when_user_registers') }} </label>
            </div>
            <div class="form-group list row">
              <div class="col-md-1 col-form-label">
                <input type="checkbox" v-model="item.surname_view_restrict" name="" id="opt6">
              </div>
              <label class="col-md-9 col-form-label" for="opt6"> {{ $t('general.users_surnames_appear_XXX') }} </label>
            </div>
            <div class="form-group list row">
              <div class="col-md-1 col-form-label">
                <input type="checkbox" v-model="hierarchy" name="" id="opt7">
              </div>
              <label class="col-md-9 col-form-label" for="opt7"> {{ $t('general.enable_user_hierarchy') }} </label>
            </div>
            <div class="form-group list row">
              <div class="col-md-1 col-form-label">
                <input type="checkbox" v-model="chat_is_disabled" name="" id="opt88">
              </div>
              <label class="col-md-9 col-form-label" for="opt88"> {{ $t('general.chat_is_disable') }} </label>
            </div>
            <div class="form-group list row">
              <div class="col-md-1 col-form-label">
                <input type="checkbox" v-model="hide_online_users" name="" id="opt89">
              </div>
              <label class="col-md-9 col-form-label" for="opt89"> {{ $t('general.hide_online_users') }} </label>
            </div>
            <div class="form-group list row">
              <div class="col-md-1 col-form-label">
                <input type="checkbox" v-model="hide_copyright_notice" name="" id="opt90">
              </div>
              <label class="col-md-9 col-form-label" for="opt90"> {{ $t('general.hide_footer_area') }} </label>
            </div>

            <div class="form-group list row">
              <div class="col-md-1 col-form-label">
                <input type="checkbox" v-model="show_search_field" name="" id="opt91">
              </div>
              <label class="col-md-9 col-form-label" for="opt91"> {{ $t('general.show_what_to_learn_today') }}</label>
            </div>

            <div class="form-group list row">
              <div class="col-md-1 col-form-label">
                <input type="checkbox" v-model="social_channels_user_can_create" name="" id="opt92">
              </div>
              <label class="col-md-9 col-form-label" for="opt92"> {{ $t('general.users_can_create_social_channel') }}</label>
            </div>

          </form>
          <div class="uk-flex uk-flex-right p-4">
            <button class="btn btn-default" @click.prevent="onSubmit"> {{ $t("general.save") }} </button>
          </div>
        </div>
        <!-- aydınlatma metni  -->
        <div class="card rounded" v-if="isActiveLegalTexts">
          <div class="p-3 d-flex justify-content-between">
            <h4 class="mb-0"><i class="uil-file-contract-dollar"></i> {{ $t('general.kvkk_and_privacy_texts') }}</h4>
          </div>
          <hr class="m-0">
          <div class="p-4">
            <legal-texts-editor :company-id="item?.id" />
          </div>
        </div>

        <div class="card rounded" v-if="isActiveAppearance">

          <div class="p-3 d-flex justify-content-between">
            <h4 class="mb-0"><i class="uil-paint-tool"></i> {{ $t('general.view_settings') }}</h4>
          </div>
          <hr class="m-0">
          <default-loading v-if="form_loading"></default-loading>
          <form v-else class="uk-child-width-2-2@s uk-grid-small p-4" uk-grid>
            <div class="form-group row">
              <div class="col-md-6">
                <label class="col-form-label">{{ $t('general.icon_color') }} <span class="required"></span></label>
                <!--color picker-->
                <input type="color" v-model="iconColor" @input="applyTheme()" />
              </div>
              <div class="col-md-6">
                <label class="col-form-label"> {{ $t('general.ground_color') }} <span class="required"></span></label>
                <!--color picker-->
                <input type="color" v-model="backgroundColor" @input="applyTheme()" />
              </div>
              <!-- <div class="col-md-6">
                <label class="col-form-label"> Font rengi <span class="required"></span></label> -->
              <!--color picker-->
              <!-- <input type="color" v-model="fontColor" @input="applyTheme()" />
              </div> -->
              <div class="col-md-6">
                <label class="col-form-label">{{ $t('general.default_button_color') }}<span class="required"></span></label>
                <!--color picker-->
                <input type="color" v-model="primaryColor" @input="applyTheme()" />

              </div>
              <div class="col-md-6">
                <label class="col-form-label">{{ $t('general.passive_button_color') }} <span class="required"></span></label>
                <!--color picker-->
                <input type="color" v-model="secondaryColor" @input="applyTheme()" />
              </div>
              <div class="col-md-6">
                <label class="col-form-label">{{ $t('general.danger_button_color') }} <span class="required"></span></label>
                <!--color picker-->
                <input type="color" v-model="dangerColor" @input="applyTheme()" />
              </div>
              <div class="col-md-6">
                <label class="col-form-label">{{ $t('general.success_button_color') }} <span class="required"></span></label>
                <!--color picker-->
                <input type="color" v-model="successColor" @input="applyTheme()" />
              </div>
              <div class="col-md-6">
                <label class="col-form-label">{{ $t('general.warning_button_color') }}<span class="required"></span></label>
                <!--color picker-->
                <input type="color" v-model="warningColor" @input="applyTheme()" />
              </div>
              <div class="col-md-6">
                <label class="col-form-label">{{ $t('general.info_button_color') }} <span class="required"></span></label>
                <!--color picker-->
                <input type="color" v-model="infoColor" @input="applyTheme()" />
              </div>

            </div>
            <div class="uk-flex uk-flex-right p-4">
              <button type="button" class="uk-button uk-button-outline mr-2" @click="resetColor">
                {{ $t('general.reset_settings') }}
              </button>
            </div>
            <h4 class="mb-0">Sosyal Medya Linkleri</h4>
            <div class="social-input">
              <i class="icon-brand-linkedin"></i>
              <input v-model="linkedinLink" type="text" placeholder="LinkedIn linki giriniz" class="basic-input" />
            </div>

            <div class="social-input">
              <i class="icon-brand-instagram"></i>
              <input v-model="instagramLink" type="text" placeholder="Instagram linki giriniz" class="basic-input" />
            </div>

            <div class="social-input">
              <i class="icon-brand-facebook"></i>
              <input v-model="facebookLink" type="text" placeholder="Facebook linki giriniz" class="basic-input" />
            </div>

            <div class="social-input">
              <i class="icon-brand-youtube"></i>
              <input v-model="youtubeLink" type="text" placeholder="YouTube linki giriniz" class="basic-input" />
            </div>
          </form>
          <div class="uk-flex uk-flex-right p-4">
            <button class="btn btn-default" @click.prevent="onSubmit('theme')"> {{ $t("general.save") }} </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css'

import DataTable from "@/assets/components/dataTable/DataTable";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import Multiselect from "vue-multiselect";
import LegalTextsEditor from "@/view/company/Settings/LegalTextsEditor.vue";
import { syncHierarchyFromService } from "@/core/services/store.js";
import module, {
  BASE_URL,
  GET_ITEM,
  UPDATE_ITEM,
  UPDATE_SELF,
  NEW_UPDATE_SELF,
  MODULE_NAME,
  ITEM, ERROR,
  RESET_POINTS
} from "@/core/services/store/company.module";
import store from "@/core/services";
import axios from "axios";
import Swal from "sweetalert2";

import $ from "jquery";
import company_module, {
  BASE_URL as COMPANY_BASE_URL,
  GET_ITEM as COMPANY_GET_ITEMS,
  ITEM as COMPANY_ITEM,
  MODULE_NAME as COMPANY_MODULE_NAME
} from "@/core/services/store/company.module";
import { showError } from "@/utils/alertUtils";
export default {
  name: "CompanySettings",
  components: { DataTable, DefaultLoading, Multiselect, LegalTextsEditor },
  data() {
    return {
      iconColor: "#93949c",
      infoColor: "#00b8d9",
      backgroundColor: "#666CFF",
      primaryColor: '#3F51B5',
      secondaryColor: '#eff2f7',
      dangerColor: '#EC5252',
      successColor: '#36b37e',
      warningColor: '#ffab00;',
      // themeColor: '#3e416d',
      fontColor: '#666CFF',
      successMessage: null,
      form_loading: false,
      isActiveAccount: true,
      isActiveUser: false,
      isActiveAppearance: false,
      isActiveLegalTexts: false,
      member_status: null,
      login_types: [],
      authentication_types: [],
      chat_is_disabled: false,
      hide_online_users: false,
      hide_copyright_notice: false,
      hide_search_field: false,
      show_search_field: false,
      hierarchy: false,
      social_channels_user_can_create: true,
      linkedinLink: 'https://tr.linkedin.com/company/anzeraogrenmeteknolojileri',
      instagramLink: 'https://www.instagram.com/anzeraofficial',
      facebookLink: 'https://tr-tr.facebook.com/pages/category/Computer-Company/Anzera-%C3%96%C4%9Frenme-Teknolojileri-601130579942407',
      youtubeLink: 'https://www.youtube.com/channel/UCYlNDP2rbHqxD95wbsOSyKw',
      domains_allowed_to_register: [],
      defaultDomains: [],
    }
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule)
      }
    }
    registerStoreModule(MODULE_NAME, module)
  },
  computed: {
    item: {
      get() {
        return store.getters[MODULE_NAME + '/' + ITEM]
      },
      set(value) {
      }
    },
    errorMessages: {
      get() {
        return store.getters[MODULE_NAME + '/' + ERROR]
      },
      set(value) {
      }
    }
  },
  methods: {
    getCompanyItem() {
      this.$store.dispatch(COMPANY_MODULE_NAME + "/" + COMPANY_GET_ITEMS, {
        url: COMPANY_BASE_URL + "/self",
      }).then((response) => {
        syncHierarchyFromService(response);
        this.$root.$emit('company:updated', response);
      });
    },
    applyTheme(colors) {
      const root = document.documentElement;
      const themeVars = colors || {
        iconColor: this.iconColor,
        backgroundColor: this.backgroundColor,
        primaryColor: this.primaryColor,
        secondaryColor: this.secondaryColor,
        dangerColor: this.dangerColor,
        infoColor: this.infoColor,
        successColor: this.successColor,
        warningColor: this.warningColor
      };

      Object.keys(themeVars).forEach(key => {
        const value = themeVars[key];
        if (value === undefined) return;

        if (key !== 'iconColor' && key !== 'backgroundColor') {
          this[key] = value;            // SADECE bu olsun
          return;
        }

        this[key] = value;
        root.style.setProperty(`--${key}`, value);
      });


    },

    resetColor() {
      this.applyTheme({
        iconColor: "#93949c",
        infoColor: "#00b8d9",
        backgroundColor: "#666CFF",
        // fontColor: this.fontColor,
        primaryColor: '#3F51B5',
        secondaryColor: '#eff2f7',
        dangerColor: '#EC5252',
        successColor: '#36b37e',
        warningColor: '#ffab00'
      });
    },
    getAuthenticationTypes() {
      let types = []
      axios.get(`api/user/authentication-types`, {
        headers: this.apiHeaders
      }).then((result) => {
        result.data.forEach(data => {
          types.push({
            id: data.id,
            name: data.name
          })
        });
      })
      this.authentication_types = types
    },
    getLoginTypes() {
      let types = []
      axios.get(`api/user/login-types`, {
        headers: this.apiHeaders
      }).then((result) => {
        result.data.forEach(data => {
          types.push({
            id: data.id,
            name: data.name
          })
        });
      })
      this.login_types = types
    },
    changeIsActive(data) {
      this.isActiveAccount = false;
      this.isActiveUser = false;
      this.isActiveAppearance = false;
      this.isActiveLegalTexts = false;

      if (data === 1) {
        this.isActiveAccount = true;
      } else if (data === 2) {
        this.isActiveUser = true;
      } else if (data === 3) {
        this.isActiveAppearance = true;
      } else if (data === 4) {
        this.isActiveLegalTexts = true;
      }

      return false;
    },
    onSubmitSelf() {
      let self = this;
      self.form_loading = true
      this.successMessage = null;

      let form = this.item;

      let formData = new FormData();
      formData.append('point_coin_rate', form.point_coin_rate);
      formData.append('most_popular_education_rate', form.most_popular_education_rate);
      formData.append('search_bg_image', form.search_bg_image);
      formData.append('_method', 'PUT')

      // Kullanıcılar Kendileri Üye Olabilsin ilk tab alanına taşındığı için , yapılan değişimde onSubmit tetiklendi
      this.onSubmit()

      self.$store.dispatch(MODULE_NAME + '/' + NEW_UPDATE_SELF, {
        url: BASE_URL + '/update-self/' + self.item.id,
        contents: formData,
      }).then(() => {
        if (!self.errorMessages) {
          self.successMessage = self.$t('profile.your_information_updated')
          self.form_loading = false
        }
      })
    },
    onClickResetPoints() {
      let self = this;
      Swal.fire({
        title: this.$t("general.reset_points_confirm"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("general.yes"),
        cancelButtonText: this.$t("general.cancel"),
        confirmButtonColor: "#e31748",
      }).then((result) => {
        if (result.isConfirmed) {
          self.form_loading = true
          self.successMessage = null;
          store.dispatch(
            MODULE_NAME + "/" + RESET_POINTS,
            {
              contents: {
                'company_id': self.item.id,
              }
            }
          ).then(response => {
            if (!self.errorMessages) {
              self.successMessage = self.$t('profile.your_information_updated')
            }
            self.form_loading = false
          });
        }
      });
    },
    onClickResetCoins() {
      let self = this;
      Swal.fire({
        title: this.$t("general.reset_coins_confirm"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("general.yes"),
        cancelButtonText: this.$t("general.cancel"),
        confirmButtonColor: "#e31748",
      }).then((result) => {
        if (result.isConfirmed) {
          self.form_loading = true;
          self.successMessage = null;
          axios.post(`api/company/reset-coins`, {}, {
            headers: self.apiHeaders
          }).then((result) => {
            if (result) {
              if (!self.errorMessages) {
                self.successMessage = self.$t('profile.your_information_updated');
              }
              self.form_loading = false;
            }
          }).catch(() => {
            // Hata durumunu burada handle edebilirsin
            self.form_loading = false;
          });
        }
      });
    },

    async onSubmit(event = null) {
      this.successMessage = null;
      this.form_loading = true;

      let form = null;
      let url = '';

      if (event === 'theme') {
        // Tema ayarları
        form = {
          key: "theme_settings",
          value: {
            iconColor: this.iconColor,
            backgroundColor: this.backgroundColor,
            // fontColor: this.fontColor,
            primaryColor: this.primaryColor,
            secondaryColor: this.secondaryColor,
            dangerColor: this.dangerColor,
            successColor: this.successColor,
            warningColor: this.warningColor,
            infoColor: this.infoColor,
            linkedinLink: this.linkedinLink,
            facebookLink: this.facebookLink,
            instagramLink: this.instagramLink,
            youtubeLink: this.youtubeLink
          }
        };
        url = `${BASE_URL}/${this.item.id ?? this.item.data.id}/settings`;
      } else {
        // Kullanıcı ayarları
        form = {
          login_type_id: this.item.login_type_id,
          authentication_type_id: this.item.authentication_type_id,
          password_change_required: this.item.password_change_required ? 1 : 0,
          is_allowed_register_user: this.item.is_allowed_register_user ? 1 : 0,
          domains_allowed_to_register: this.item.is_allowed_register_user ? this.domains_allowed_to_register : [],
          is_allowed_login_type: this.item.is_allowed_login_type ? 1 : 0,
          is_allowed_authentication_type: this.item.is_allowed_authentication_type ? 1 : 0,
          auto_training_assignment: this.item.auto_training_assignment ? 1 : 0,
          surname_view_restrict: this.item.surname_view_restrict ? 1 : 0,
          settings: [
            { key: "chat_is_disabled", value: this.chat_is_disabled ? 1 : 0 },
            { key: "hide_online_users", value: this.hide_online_users ? true : false },
            { key: "hide_copyright_notice", value: this.hide_copyright_notice ? true : false },
            { key: "hide_search_field", value: this.hide_search_field ? true : false },
            { key: "show_search_field", value: this.show_search_field ? true : false },
            { key: "hierarchy", value: this.hierarchy ? true : false },
            { key: "social_channels_user_can_create", value: this.social_channels_user_can_create ? true : false }
          ]
        };

        if (!this.item.is_allowed_register_user) {
          this.domains_allowed_to_register = []
        }

        url = `${BASE_URL}/update-settings/${this.item.id ?? this.item.data.id}`;
      }

      try {
        await this.$store.dispatch(`${MODULE_NAME}/${UPDATE_SELF}`, {
          url,
          contents: form
        });

        // Başarı mesajı ve getCompanyItem çağrısı
        setTimeout(() => {
          if (!this.errorMessages) {
            this.successMessage = this.$t('profile.your_information_updated');
            this.form_loading = false;
            this.getCompanyItem();
          }
        }, 500);

      } catch (error) {
        console.error("Settings update failed:", error);
        this.form_loading = false;
      }
    },
    onClickEdit(id) {
      if (id !== this.parentMemberId) {
        let routeData = this.$router.resolve({ name: "EditUser", params: { id: id } });
        window.open(routeData.href, '_blank');
      }
    },
    processFile(event) {
      let imageInput = event.target.files[0];
      this.item.search_bg_image = imageInput;
      let blob = URL.createObjectURL(imageInput);
      let imageHolder = $('.logoarea');
      imageHolder.attr('src', blob);
    },
    inputClick() {
      $('#avatar').click();
    },
    addDomain(newDomain) {
      // Domain formatı kontolu (xxx.yyy)
      const domainRegex = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

      if (domainRegex.test(newDomain)) {
        // Eğer domain zaten listede yoksa ekle
        if (!this.domains_allowed_to_register.includes(newDomain)) {
          this.domains_allowed_to_register.push(newDomain);
        }
      } else {
        showError(this.$t("general.invalid_domain_format"))
      }
    },
  },
  mounted() {
    this.$store.dispatch(MODULE_NAME + '/' + GET_ITEM, {
      url: BASE_URL + '/self'
    }).then((response) => {
      let settings = response?.settings?.find(x => x.key === 'theme_settings');
      let chat_settings = response?.settings?.find(x => x.key === 'chat_is_disabled');
      this.hide_online_users = response?.settings?.find(x => x.key === 'hide_online_users')?.value;
      this.hide_copyright_notice = response?.settings?.find(x => x.key === 'hide_copyright_notice')?.value;
      this.hide_search_field = response?.settings?.find(x => x.key === 'hide_search_field')?.value;
      const show_search_field = response?.settings?.find(x => x.key === 'show_search_field')?.value;
      this.show_search_field = show_search_field === 1 || show_search_field === true || show_search_field === "1" || show_search_field === "true";
      this.hierarchy = response?.settings?.find(x => x.key === 'hierarchy')?.value;
      this.social_channels_user_can_create = response?.settings?.find(x => x.key === 'social_channels_user_can_create')?.value !== undefined
        ? response?.settings?.find(x => x.key === 'social_channels_user_can_create')?.value
        : true;
      this.chat_is_disabled = chat_settings
        ? chat_settings.value === 1 || chat_settings.value === true || chat_settings.value === "1" || chat_settings.value === "true"
        : false;
      this.iconColor = settings?.value?.iconColor || this.iconColor;
      this.backgroundColor = settings?.value?.backgroundColor || this.iconColor;
      // this.fontColor = settings?.value?.fontColor;
      this.primaryColor = settings?.value?.primaryColor || this.primaryColor;
      this.secondaryColor = settings?.value?.secondaryColor || this.secondaryColor;
      this.successColor = settings?.value?.successColor || this.successColor;
      this.dangerColor = settings?.value?.dangerColor || this.dangerColor;
      this.warningColor = settings?.value?.warningColor || this.warningColor;
      this.infoColor = settings?.value?.infoColor || this.infoColor;
      this.linkedinLink = settings?.value?.linkedinLink || this.linkedinLink;
      this.facebookLink = settings?.value?.facebookLink || this.facebookLink;
      this.youtubeLink = settings?.value?.youtubeLink || this.youtubeLink;
      this.instagramLink = settings?.value?.instagramLink || this.instagramLink;


      if (response?.domains_allowed_to_register && Array.isArray(response.domains_allowed_to_register) && response.domains_allowed_to_register.length > 0) {
        this.domains_allowed_to_register = response.domains_allowed_to_register;
        this.defaultDomains = []
      } else {
        this.domains_allowed_to_register = [];
        this.defaultDomains = ['gmail.com', 'anzera.com.tr'];
        this.item.is_allowed_register_user = false
      }
    });
    this.getAuthenticationTypes()
    this.getLoginTypes()
  }
};
</script>
<style>
.btn-warning-light {
  background-color: #ffc107cc;
  /* Bootstrap warning renginin daha açık (yarı saydam) hali */
  border-color: #ffc107cc;
  color: #212529;
  /* koyu yazı rengi */
}

.btn-warning-light:hover {
  background-color: #ffcd39;
  border-color: #ffcd39;
}

.social-input {
  display: flex;
  align-items: center;
  gap: 10px;
  /* ikon ile input arasındaki boşluk */
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 12px;
  width: 100%;
  /* tam satır */
  box-sizing: border-box;
}

.social-input i {
  font-size: 22px;
  /* ikon boyutu büyütüldü */
  min-width: 22px;
  /* ikon sabit kalsın */
  text-align: center;
}

.basic-input {
  flex: 1;
  /* tüm boşluğu kaplasın */
  border: none;
  outline: none;
  font-size: 15px;
  padding: 6px 0;
}

.multiselect__tags .multiselect__input {
  border: unset !important;
}
</style>
